module.exports = __webpack_public_path__ + "img/computo.0d07a823.svg";